import {
  styled,
  Button,
  CircularProgress as BaseCircularProgress,
} from '@material-ui/core'

export const LOADER_SIZE = 28

export const ButtonWithLoader = styled(Button)(
  ({ isLoading }: { isLoading?: boolean }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    '& p': {
      opacity: isLoading ? 0 : 1,
    },
    '& a': {
      opacity: isLoading ? 0 : 1,
      textDecoration: 'none',
      color: 'inherit',
      display: 'flex',
      alignItems: 'center',
    },
  })
)

export const CircularProgress = styled(BaseCircularProgress)({
  position: 'absolute',
  left: `calc(50% - ${LOADER_SIZE / 2}px)`,
})
